"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyProfile = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _auth = require("../../redux/modules/auth");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _UserProfileForm = require("../../components/myprofile/UserProfileForm");

var _UserProfileForm2 = _interopRequireDefault(_UserProfileForm);

var _userUpdateValidator = require("./userUpdateValidator");

var _userUpdateValidator2 = _interopRequireDefault(_userUpdateValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyProfile = exports.MyProfile = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyProfile, _Component);

  function MyProfile() {
    (0, _classCallCheck3.default)(this, MyProfile);
    return (0, _possibleConstructorReturn3.default)(this, (MyProfile.__proto__ || (0, _getPrototypeOf2.default)(MyProfile)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyProfile, [{
    key: "render",


    // TODO: check this with userAdForm
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Profiili" }),
        _react2.default.createElement(_UserProfileForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          auth: this.props.auth,
          userUpdate: this.props.userUpdate
        })
      );
    }
  }]);
  return MyProfile;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  userUpdate: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  userUpdate: _auth.userUpdate
})((0, _reduxForm.reduxForm)({
  form: "userUpdateForm",
  fields: ["first_name", "last_name", "phone", "email", "password", "password2", "send_transfer_requests", "address", "postal_code", "postal_area", "order_reference"],
  validate: _userUpdateValidator2.default
})(MyProfile));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyProfile/MyProfile.js
 ** module id = 1221
 ** module chunks = 0
 **/